import { mergeClassName } from '../../utils/mergeClassName'

type ReactDiv = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

type PageContentProps = {
  topContent?: React.ReactNode
} & ReactDiv

const PageContent: React.FC<PageContentProps> = ({
  topContent,
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={mergeClassName(
        'flex w-full justify-center',
        className,
      )}
    >
      <div className={mergeClassName(
        'w-full max-w-[1236px] bg-white',
      )}
      >
        { topContent && (
          <div>
            { topContent }
          </div>
        ) }
        <div className="px-2 py-6 sm:px-4 md:px-6 lg:p-12">
          { children }
        </div>
      </div>
    </div>

  )
}

export default PageContent
